import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../services/authService';
import './styles/Login.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    setSubmitting(true);
    try {
      const data = await forgotPassword({ email });
      setMsg(data?.message || 'OTP sent');
      navigate('/reset-password', { state: { email } });
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to send OTP');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-eyebrow">
            <span className="auth-eyebrow-dot" aria-hidden="true" />
            Password recovery
          </div>
          <h2 className="auth-title">Forgot password?</h2>
          <p className="auth-subtitle">
            Enter your email and we&apos;ll send you a one-time code to reset your password.
          </p>
        </div>

        {msg && (
          <div className="auth-alert" role="alert"
            style={{ borderColor: 'rgba(34,197,94,0.25)', background: 'rgba(34,197,94,0.07)', color: 'rgba(187,247,208,0.95)' }}>
            {msg}
          </div>
        )}
        {error && <div className="auth-alert" role="alert">{error}</div>}

        <form onSubmit={onSubmit} className="auth-form" noValidate>
          <div className="auth-field">
            <label className="auth-label">Email address</label>
            <input
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <button className="auth-button" disabled={submitting} type="submit">
            {submitting ? 'Sending…' : 'Send Reset Code →'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login" className="auth-link">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
